import type { ReactNode } from "react";

interface AuthDesktopRightPaneProps {
  title?: string;
  children: ReactNode;
}

export function AuthDesktopRightPane({
  title,
  children,
}: AuthDesktopRightPaneProps) {
  return (
    <div className="flex w-full min-w-0 flex-1 flex-col items-center justify-center bg-[#F6F6F9] px-6 py-8 sm:px-8 sm:py-10 md:w-[48%] md:px-8 md:py-10 lg:w-[42.36%] lg:px-10 lg:py-12 xl:px-12 xl:py-12 2xl:px-[148px] 2xl:py-16">
      <div className="w-full max-w-[18.5rem] md:max-w-[18rem] lg:max-w-[19rem] xl:max-w-[19.5rem] 2xl:max-w-[20rem]">
        {title && (
          <h2 className="mb-6 text-center text-[1.25rem] leading-snug font-semibold tracking-tight text-[#212330] md:mb-6 md:text-[1.5rem] lg:mb-8 lg:text-[1.625rem] xl:mb-10 xl:text-[1.875rem] xl:leading-tight 2xl:mb-14 2xl:text-4xl 2xl:leading-none">
            {title}
          </h2>
        )}
        {children}
      </div>
    </div>
  );
}
